import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "foot_bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, " @2024 炎黄盈动 京ICP备 13014359号-8京公安网备 11010802013640号增值电信业务经营许可证编号：合字B2-20210345 "))
}